import { SummaryRow } from '../../../Summary/SummaryRow';
import { Q } from '../../../../store/student/types';
import { IOtherName, IRisk } from '../../../../types';
import { SummaryList } from '../../../Summary/SummaryList';
import { SummaryListItem } from '../../../Summary/SummaryListItem';

interface Props {
  showRisks: boolean;
  surname?: string;
  middleName?: string;
  givenName?: string;
  hasOtherNames: string;
  otherNames?: Array<IOtherName>;
  riskList: IRisk['personalInfoRisk']['namesAndAliases'];
}

function NameAndDOB({ showRisks, surname, middleName, givenName, hasOtherNames, otherNames, riskList }: Props) {
  return (
    <>
      {givenName && (
        <SummaryRow
          key="giveName"
          label="Given Name"
          value={givenName}
          isRisk={showRisks && riskList.includes(Q.GIVEN_NAME)}
        />
      )}
      {middleName && (
        <SummaryRow
          key="middleName"
          label="Middle Name"
          value={middleName}
          isRisk={showRisks && riskList.includes(Q.MIDDLE_NAME)}
        />
      )}
      {surname && (
        <SummaryRow
          key="surname"
          label="Family Name"
          value={surname}
          isRisk={showRisks && riskList.includes(Q.SURNAME)}
        />
      )}
      {hasOtherNames && (
        <SummaryRow
          key="hasOtherNames"
          label="Has Other Names"
          fullLabel="In addition to the names already provided, are you now or have you ever been known by another name?"
          value={hasOtherNames}
          isRisk={showRisks && riskList.includes(Q.HAS_OTHER_NAMES)}
        />
      )}
      {hasOtherNames && otherNames !== undefined && (
        <SummaryRow className={'summary'} value={otherNames?.length} label={`How many`} fullLabel={'How many names?'} />
      )}
      {hasOtherNames === 'Yes' && otherNames !== undefined && (
        <>
          <SummaryList
            title="Alternative or Previous Names"
            tooltip={`Other Given Name(s) & Other Family Name & Reason for Other Name?`}
          >
            {otherNames.map((name, index) => {
              return (
                <SummaryListItem
                  key={`other-name-${index}`}
                  value={`${name.givenName} - ${name.surname}`}
                  subvalue={`Reason: ${name.reason}`}
                />
              );
            })}
          </SummaryList>
        </>
      )}
    </>
  );
}

export default NameAndDOB;
